// @flow
import PlainMenu from './PlainMenu';
import PlainMenuItem from './PlainMenuItem';

export default PlainMenu;
export { PlainMenuItem };
